module.exports = __webpack_public_path__ + "img/builder-5.30a1d1ac.jpg";